import { isValidTimerPosition, MAX_POSITION_AGE_MS, TimerPosition } from "./timer-position";

export const GPS_HISTORY_MS = 3 * 60_000;

/** Last valid fix at or before the event, never a later airborne position.
 * A gap longer than one minute cannot reliably describe that event. */
export function departurePositionAt(
  history: { time: number; lat: number; lon: number }[],
  eventTime: number
): TimerPosition | undefined {
  let best: { time: number; lat: number; lon: number } | undefined;
  for (const fix of history) {
    if (!Number.isFinite(fix.time) || fix.time > eventTime || eventTime - fix.time > MAX_POSITION_AGE_MS) continue;
    if (!isValidTimerPosition([fix.lon, fix.lat])) continue;
    if (!best || fix.time > best.time) best = fix;
  }
  return best ? [best.lon, best.lat] : undefined;
}
